<template>
  <div class="S4 tip" :class="tipClass" v-if="resp.detail&&resp.detail.tip" @click="goAd()">
    <div>
      {{resp.detail? resp.detail.tip.text:"" }}
    </div>
    <div class="viewDetail" v-if="viewDetail">
      查看详情
      <van-icon name="arrow" />
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import { Icon } from 'vant'
import util from "@/util/util";

export default {
  name: "AdTip",
  props: {
    tipClass:{
      default: '',
      type: String
    },
    viewDetail:{
      default: true,
      type: Boolean
    }
  },
  components: {
    'van-icon': Icon,
  },
  computed: {
    ...mapState('video', ['resp']),
  },
  methods: {
    goAd() {
      console.log(this.resp.detail.tip.url)
      util.go(this.resp.detail.tip.url)
    }
  },
}
</script>

<style scoped lang="scss">
.tip {
  background: #fadbd5;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-top:20px;
  padding-bottom:18px;
  color: #e64c2e;
  &.blue {
    background: rgba(4,107,204,0.2);
    color: #046BCC;
  }
}

.viewDetail {
  margin-right: 30px;
}

.viewDetail img {
  width: 12px;
  height: 20px;
}
</style>